{
  "birthDate": "您的出生日期",
  "dateFormat": "dd/mm/yyyy",
  "familyName": "您的姓氏",
  "helpMessage": "<p>如果上方的号码不正确，或者您不确定该怎么做，请致电 <a><strong>{{phone}}</strong></a>（然后按 <strong>选项 2</strong>）。</p>",
  "sendCode": "发送验证码",
  "text": "<p>此预约邀请是为由手机号码 <strong><PhonePlaceholder /></strong> 所照护的患者而发出的。</p>\n<p>如果是您本人，请在下方输入<strong>患者的姓氏</strong>和<strong>出生日期</strong>，然后点击按钮。</p>\n<p>为保障安全，我们将向您发送一次性<strong>4位数验证码</strong>以验证身份。</p>",
  "title": "欢迎使用 <strong>{{company}} 在线预约</strong>"
}
